import React from 'react';
import { motion } from 'framer-motion';
import { Activity, Layers } from 'lucide-react';
export function PlatformOverview() {
  return <section className="py-20 lg:py-28 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" id="platform" data-id="element-714">
      <div className="text-center mb-16" data-id="element-715">
        <span className="text-xs font-semibold text-teal uppercase tracking-[0.2em] mb-4 block" data-id="element-716">
          Platform Structure
        </span>
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-ink-dark" data-id="element-717">
          One platform. Multiple layers of development.
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-718">
        {/* Card 1: CJI */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5
      }} className="bg-surface-card rounded-lg p-8 lg:p-10 border border-line shadow-premium hover:shadow-premium-hover transition-shadow duration-300 relative overflow-hidden group" data-id="element-719">
          <div className="absolute top-0 left-0 w-full h-1 bg-navy transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500" data-id="element-720"></div>

          <div className="w-12 h-12 rounded-md bg-surface-muted flex items-center justify-center text-navy mb-8 border border-line" data-id="element-721">
            <Activity size={24} strokeWidth={1.5} data-id="element-722" />
          </div>

          <div className="flex items-baseline gap-3 mb-4" data-id="element-723">
            <h3 className="text-2xl font-heading font-bold text-ink-dark" data-id="element-724">
              CJI
            </h3>
            <span className="text-sm font-medium text-ink-muted" data-id="element-725">
              Civic Judgment Index
            </span>
          </div>

          <p className="text-ink-muted leading-relaxed text-lg" data-id="element-726">
            Decision-quality analytics, propaganda-resistance profiling,
            cognitive assessment, and leadership reasoning diagnostics.
          </p>
        </motion.div>

        {/* Card 2: NCJI */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="bg-surface-card rounded-lg p-8 lg:p-10 border border-line shadow-premium hover:shadow-premium-hover transition-shadow duration-300 relative overflow-hidden group" data-id="element-727">
          <div className="absolute top-0 left-0 w-full h-1 bg-teal transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500" data-id="element-728"></div>

          <div className="w-12 h-12 rounded-md bg-surface-muted flex items-center justify-center text-teal mb-8 border border-line" data-id="element-729">
            <Layers size={24} strokeWidth={1.5} data-id="element-730" />
          </div>

          <div className="flex items-baseline gap-3 mb-4" data-id="element-731">
            <h3 className="text-2xl font-heading font-bold text-ink-dark" data-id="element-732">
              NCJI
            </h3>
            <span className="text-sm font-medium text-ink-muted" data-id="element-733">
              Neurocognitive Civic Judgment Index
            </span>
          </div>

          <p className="text-ink-muted leading-relaxed text-lg" data-id="element-734">
            A broader developmental architecture integrating human opportunity,
            institutional readiness, civic resilience, and executive-level
            leadership evaluation.
          </p>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.3
    }} className="text-center" data-id="element-735">
        <p className="inline-block px-6 py-3 bg-surface-muted rounded-full text-sm font-medium text-navy-light border border-line" data-id="element-736">
          This is not a static score. It is a progression system.
        </p>
      </motion.div>
    </section>;
}